import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaSchool, FaUniversity, FaBuilding } from "react-icons/fa";

const Experience = () => {
  return (
    <section className="experience_section">
      <div className="container">
        <h2 className="about_main_heading">Education & Experience</h2>

        <div className="row">
          <div className="col-lg-12">
            <VerticalTimeline>
              {/* Intermediate */}
              <VerticalTimelineElement
                date="2017 - 2018"
                iconStyle={{ background: "#72e2ae", color: "#fff" }}
                icon={<FaSchool />}
              >
                <h3 className="vertical-timeline-element-title">
                  Intermediate
                </h3>
                <p>St. Xavier's School, Belthara, Ballia</p>
              </VerticalTimelineElement>

              {/* ADCA */}
              <VerticalTimelineElement
                date="2020 - 2021"
                iconStyle={{ background: "#72e2ae", color: "#fff" }}
                icon={<FaUniversity />}
              >
                <h3 className="vertical-timeline-element-title">
                  Advance Diploma in Computer Application
                </h3>
                <p>Career Computer Institute, Laxmanpur, Ballia</p>
              </VerticalTimelineElement>

              {/* BCA */}
              <VerticalTimelineElement
                date="Jan 2022 - Jan 2025"
                iconStyle={{ background: "#72e2ae", color: "#fff" }}
                icon={<FaUniversity />}
              >
                <h3 className="vertical-timeline-element-title">
                  Bachelor of Computer Application
                </h3>
                <p>Online Distance Learning</p>
              </VerticalTimelineElement>

              {/* Java Fullstack */}
              <VerticalTimelineElement
                date="Feb 2023 - Feb 2024"
                iconStyle={{ background: "#72e2ae", color: "#fff" }}
                icon={<FaBuilding />}
              >
                <h3 className="vertical-timeline-element-title">
                  Java Fullstack Training
                </h3>
                <p>Ducat IT Training Center</p>
              </VerticalTimelineElement>
            </VerticalTimeline>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
